'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SwapRightOutlined = _interopRequireDefault(require('./lib/icons/SwapRightOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _SwapRightOutlined;
exports.default = _default;
module.exports = _default;